<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <form @submit.prevent="rejectExpense" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('expenses.reject') }}</h5>
          </div>

          <div class="modal-body">
            <div class="row">
                  <Input
                    :name="`${id}_expense_motif`"
                    type="text"
                    :label="$t('expenses.label.motif')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    :isRequired="true" size="lg"
                    :placeholder="$t('expenses.label.motif')"
                    v-model="formData.motif"
                />
            </div>
          </div>
          <div class="modal-footer">
            <Button btn-class="btn-sm me-3" type="submit" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>
import {ref, defineProps, onMounted, watch} from "vue";
import {useStore} from "vuex";

import Button from "@/components/Button.vue"
import { useRoute } from "vue-router";
import Input from "@/components/Input.vue";
 
const store = useStore()
const route = useRoute()
const props = defineProps({
  id: {
      type: String,
      required: true
  },
  callback: {
      type: Function,
      required: false,
      default: () => {}
  },
  data: {
    type: Object,
    default: () => {}
  }
})

watch(() => props.data, (value) => {
  if(value && value.id) {
    formData.value.id = value.id
  }
}, {deep: true})

const isLoading = ref(false)
const formData = ref( 
  {
    id: route.params.id,
    motif: ""
  }
)
function rejectExpense() {
  isLoading.value = true
      store.dispatch('expenses/rejectExpense', formData.value)
        .then(() => {
          $("#"+props.id).modal('toggle');
          props.callback()
          window.toastr['success'](i18n.global.t('notification.expense_rejected'))
        })
        .catch(() => {
        })
        .finally(() => isLoading.value = false)
    
}


onMounted(() => {
  
})
</script>

<style scoped></style>
